import { get, reduce, size, split, indexOf } from 'lodash-es';
import { checkIsNull } from '../../Utils/utils';

/**
 * parse string to json
 * @param {*} string
 */
export const parseToJson = string => {
  try {
    // convert to valid JSON
    const s = string
      // eslint-disable-next-line no-useless-escape
      .split(/\&#39;|\&quot;/)
      .join('"')
      .replace(/\\n/g, '\\n')
      .replace(/\\'/g, '\\"')
      .replace(/\\"/g, '\\"')
      .replace(/\\&/g, '\\&')
      .replace(/\\r/g, '\\r')
      .replace(/\\t/g, '\\t')
      .replace(/\\b/g, '\\b')
      .replace(/\\f/g, '\\f')
      // eslint-disable-next-line no-control-regex
      .replace(/[\u0000-\u0019]+/g, '');

    const json = JSON.parse(s);

    if (json && typeof json === 'object') {
      return json;
    }
    return false;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`parseToJson ${e.stack}`);
    return false;
  }
};

/**
 * parse value decimal digits
 * @param {*} value
 * @param {*} digits
 */
export const parseValueDecimalDigits = (value, digits) => {
  try {
    if (!checkIsNull(value) && !checkIsNull(digits)) {
      const valToString = value.toString();
      const nBdecimalPart = size(split(valToString, '.')[1]);
      if (nBdecimalPart > Number(digits)) {
        return valToString.slice(0, indexOf(valToString, '.') + Number(digits) + 1);
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return value;
};

/**
 * sort by sequence
 * @param a
 * @param b
 * @returns {number}
 */
export const sortBySequence = (a, b) => {
  if (get(a, 'sequence') > get(b, 'sequence')) {
    return 1;
  }
  if (get(b, 'sequence') > get(a, 'sequence')) {
    return -1;
  }
  return 0;
};

/**
 * initialize Questions Formik
 * @param questions
 */
export const initializeQuestionsFormik = ({ questions }) => {
  try {
    return reduce(
      questions,
      (item, val) => {
        // eslint-disable-next-line no-param-reassign
        item[val.code] = val.value;
        return item;
      },
      {}
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`initializeQuestionsFormik: ${e}`);
  }
  return undefined;
};
